import { PayloadAction } from '@reduxjs/toolkit';
import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import ApprovalGateway from '~apis/approval';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';
import { TUpdateCollateralStatusReduxParams } from '~types/feat/approval';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages, SuccessMessages } from '~utils/constants';
import { TransactionStatusEnum } from '~utils/enums';

export default function* watchUpdateCollateralStatus(api: ApprovalGateway): SagaWatcherReturnType {
    yield takeEvery('approval/approvalUpdateCollateralStatusAttempt', handleUpdateCollateralStatus, api);
}

function* handleUpdateCollateralStatus(api: ApprovalGateway, data: PayloadAction<TUpdateCollateralStatusReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        id,
        status,
    } = data.payload;

    const response = yield* call([api, api.updateCollateralStatus], {
        authToken,
        id,
        status,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.approvalUpdateCollateralStatusFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        const successMessage = status === TransactionStatusEnum.Approved
            ? SuccessMessages.SettingUpdateCollateralApprovalSuccess
            : status === TransactionStatusEnum.Rejected
                ? SuccessMessages.SettingUpdateCollateralRejectedSuccess
                : '';

        yield put(combinedActions.approvalSetConfirmUpdateCollateralStatusModalIsOpen(false));
        yield put(combinedActions.approvalGetPendingCollateralListingAttempt());
        yield put(combinedActions.approvalUpdateCollateralStatusSuccess());

        toast.success(successMessage);
    }
}
